import { Identify, flush, getDeviceId, getSessionId, getUserId, identify, init, setUserId, track } from '@amplitude/analytics-browser';
const instance = {
    getDeviceId: () => Promise.resolve(getDeviceId() || ''),
    getSessionId,
    init(apiKey, userId, options = {}) {
        const attribution = options.includeReferrer || options.includeUtm;
        try {
            const initialized = init(apiKey, userId, {
                autocapture: {
                    attribution: attribution ? { trackingMethod: 'userProperty' } : false,
                    elementInteractions: false,
                    fileDownloads: false,
                    formInteractions: false,
                    frustrationInteractions: false,
                    networkTracking: false,
                    pageViews: false,
                    performanceTracking: false,
                    sessions: true,
                    webVitals: false
                }
            });
            void initialized.promise.catch(error => {
                options.onError?.(error instanceof Error ? error : new Error(String(error)));
            });
            if (options.onExitPage && typeof window !== 'undefined') {
                window.addEventListener('pagehide', options.onExitPage);
            }
            return initialized;
        }
        catch (error) {
            options.onError?.(error instanceof Error ? error : new Error(String(error)));
            throw error;
        }
    },
    logEvent(name, properties) {
        return track(name, properties);
    },
    get options() {
        return {
            deviceId: getDeviceId(),
            userId: getUserId()
        };
    },
    sendEvents() {
        return flush();
    },
    setUserId(userId) {
        setUserId(userId);
    },
    setUserProperties(properties) {
        const userProperties = new Identify();
        for (const [key, value] of Object.entries(properties)) {
            if (value !== undefined) {
                userProperties.set(key, value);
            }
        }
        return identify(userProperties);
    }
};
export default {
    getInstance: () => instance
};
